// extracted by mini-css-extract-plugin
export default {"loader":"LoadingAnimation_loader__jIrBI","mulShdSpin":"LoadingAnimation_mulShdSpin__r9gTu"};